import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  BookSessionDto,
  ParagraphSessionDto,
} from '@lyceo/lyceo-pupil-app/practise/util-models';

export const ExerciseActions = createActionGroup({
  source: 'Exercise API',
  events: {
    'Get Paragraph Session Success': props<{
      session: ParagraphSessionDto;
    }>(),
    'Get Paragraph Session Failure': props<{ error: Error }>(),
    'Get Book Session Success': props<{
      session: BookSessionDto;
    }>(),
    'Get Book Session Failure': props<{ error: Error }>(),
  },
});

export const AlfredModalActions = createActionGroup({
  source: 'Alfred Modal',
  events: {
    'Session Finished': props<{
      session: ParagraphSessionDto | BookSessionDto;
    }>(),
    'Modal Closed': emptyProps(),
  },
});
